<template>
<el-container>
  <el-header height="auto" id="home_header" :class="{ whihe_bg: whiheBg }">
    <root-header :whihe="whiheBg"></root-header>
  </el-header>
  <router-view :key="$route.fullPath"></router-view>
  <root-footer></root-footer>
</el-container>
</template>

<script>
// @ is an alias to /src
import rootHeader from '@/components/layout/RootHeader'
import rootFooter from '@/components/layout/RootFooter'

export default {
  data () {
    return {
      whiheBg: true,
      path: ''
    }
  },
  components: {
    rootHeader,
    rootFooter
  },
  watch: { // 监听路由变化
    $route (to, from) {
      this.path = to.path
      if (to.path === '/ppwc') {
        this.whiheBg = false
      } else {
        this.whiheBg = true
      }
    }
  },
  created () {
    this.path = this.$route.path
    if (this.$route.path === '/ppwc') {
      this.whiheBg = false
    } else {
      this.whiheBg = true
    }
  },
  mounted () {
    let scroll_copy = 0
    window.addEventListener('scroll', () => {
      let scrollt = document.documentElement.scrollTop + document.body.scrollTop

      if (this.path === '/ppwc') {
        if (scrollt > 50) {
          this.whiheBg = true
        } else {
          this.whiheBg = false
        }

        if (scrollt > 300 &&　scrollt > scroll_copy) {
          document.querySelector('#home_header').style.top = '-100px'
        }
        if (scrollt > 300 &&　scrollt < scroll_copy) {
          document.querySelector('#home_header').style.top = '0px'
        }
      } else {
        if (scrollt > scroll_copy) {
          document.querySelector('#home_header').style.top = '-100px'
        }
        if (scrollt < scroll_copy) {
          document.querySelector('#home_header').style.top = '0px'
        }
      }

      scroll_copy = scrollt
    })
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0px;
  font-family: 'Raleway', "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
p {
  margin: 0;
  padding: 0;
}
.center-aligned {
  text-align: center;
}
.center-margin {
  margin: 0 auto;
}
.right-floated {
  float: right;
}
.container {
  width: 1180px;
  margin: 0 auto;
  padding: 0px 10px;
}
.min-container {
  min-width: 1200px;
}
.inline-block {
  display: inline-block;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-header, .el-footer {
  min-width: 1200px;
  padding: 0px;
  // background-color: #000;
}
.el-footer {
  background: url('/official/static/img/ppwc/bg_06.jpg') no-repeat center top;
}
.whihe_bg {
  background-color: #fff;
  /deep/.lang * {
    color: #077594;
  }
}
.el-header {
  position: fixed;
  // width: 100%;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
  padding: 16px 0px;
  // background: #000;
  transition:top 500ms, background-color 500ms;
  -moz-transition:top 500ms, background-color 500ms; /* Firefox 4 */
  -webkit-transition:top 500ms, background-color 500ms; /* Safari and Chrome */
  -o-transition:top 500ms, background-color 500ms; /* Opera */
  @media only screen and (max-width: 1200px) {
    position: absolute;
  }
}
</style>
